// extracted by mini-css-extract-plugin
export default {"tooltip":"XvCz6v0qMplh5vNStW_R"};